export default "__VITE_ASSET__401dd4ba__"